module.exports = __webpack_public_path__ + "static/media/p1010972.1ff97cdc.jpg";